// UAE States/Emirates options for patient forms
export const UAE_STATE_OPTIONS = [
  { value: "Dubai", label: "Dubai" },
  { value: "Abu Dhabi", label: "Abu Dhabi" },
  { value: "Sharjah", label: "Sharjah" },
  { value: "Fujairah", label: "Fujairah" },
  { value: "Ras Al Khaimah", label: "Ras Al Khaimah" },
  { value: "Umm Al Quwain", label: "Umm Al Quwain" },
  { value: "Ajman", label: "Ajman" },
  { value: "Others", label: "Others" },
  { value: "Unknown", label: "Unknown" }
];

// Export valid state values for validation
export const VALID_UAE_STATES = UAE_STATE_OPTIONS.map(state => state.value);
